import React from 'react';
import MUIAvatar from '@mui/material/Avatar';

const Avatar = ({ src, alt,sx }) => {
    return (
            <MUIAvatar
                src={src}
                alt={alt}
                sx={sx}
            />
    );
}

export default Avatar;
